<div class="w-full px-3 flex items-center snack">

  @if (data.type === snackBarTypes.error) {
    <span class="text-base icon info-regular text-white ml-1"> </span>
  }
  @else if(data.type === snackBarTypes.success){
    <span class="text-base icon checkmark-filled text-white ml-1"></span>

  }
  @else if (data.type === snackBarTypes.warning) {
    <span class="text-base icon warning-regular text-white ml-1"></span>

  }

  <!-- ? Message -->
  <p class="text-sm text-white inline">{{ data.message }}</p>
</div>
